module.exports = __webpack_public_path__ + "static/img/avatar-s-4.88863dbb.png";